import React, { useContext } from 'react';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';
import { CursorContext } from '../context/CursorContext';
import { useTheme } from '../context/ThemeContext';

const Contact = () => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(CursorContext);
  const theme = useTheme();
  const darkMode = theme?.darkMode ?? true;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const name = formData.get('name');
    const email = formData.get('email');
    const message = formData.get('message');

    const telegramMessage = `New Contact Form Submission:\nName: ${name}\nEmail: ${email}\nMessage: ${message}`;

    try {
      const res = await fetch(
        `https://api.telegram.org/bot8398016195:AAGn-CT0S89Ml44o1Y2yshzQC9mhJQtU-6Q/sendMessage`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ chat_id: 1258909346, text: telegramMessage })
        }
      );

      const data = await res.json();

      if (data.ok) {
        alert('Message sent to Telegram!');
        e.target.reset();
      } else {
        alert('Failed to send message.');
        console.error(data);
      }
    } catch (error) {
      alert('Error occurred.');
      console.error(error);
    }
  };

  return (
    <main
      style={{
        background: darkMode
          ? 'linear-gradient(to top right, #1e1b4b, #020617, #000000)'
          : '#ffffff',
        color: darkMode ? '#ffffff' : '#0f172a',
        transition: 'all 0.3s ease',
      }}
      className="overflow-x-hidden"
    >
      <section>
        <div className="max-w-screen-lg mx-auto w-full px-8 pt-10 pb-10 lg:px-28 lg:pt-16 lg:pb-12">

          {/* Heading stays LEFT */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 1.9 }}
            variants={{
              hidden: { opacity: 0, x: 50 },
              visible: { opacity: 1, x: 0 },
            }}
          >
            <h1 className={`h1 sm:text-7xl font-bold ${darkMode ? 'text-white' : 'text-slate-900'}`}>
              Contact Me
            </h1>
          </motion.div>

          {/* Everything under heading shifted RIGHT on desktop */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 1.9 }}
            variants={{
              hidden: { opacity: 0, x: 50 },
              visible: { opacity: 1, x: 0 },
            }}
            className="w-full lg:pl-2 mt-6"
          >
            <p className={`mb-14 mt-0 text-[17px] ${darkMode ? 'text-white' : 'text-slate-700'}`}>
              Get in touch using the form.
            </p>

            <form onSubmit={handleSubmit} className="flex flex-col gap-y-6 w-full">

              <div className="flex flex-col md:flex-row gap-6 w-full">

                <div className="w-full">
                  <label className={`text-sm mb-2 block ${darkMode ? 'text-white' : 'text-slate-900'}`}>
                    Your name <span className="opacity-60">*</span>
                  </label>
                  <input
                    className={`w-full outline-none border-b h-[60px] bg-transparent font-secondary pl-3 ${
                      darkMode
                        ? 'border-b-white placeholder:text-white placeholder:opacity-40'
                        : 'border-b-slate-900 placeholder:text-slate-400'
                    }`}
                    type="text"
                    name="name"
                    required
                    placeholder="Full name"
                  />
                </div>

                <div className="w-full">
                  <label className={`text-sm mb-2 block ${darkMode ? 'text-white' : 'text-slate-900'}`}>
                    Your email <span className="opacity-60">*</span>
                  </label>
                  <input
                    className={`w-full outline-none border-b h-[60px] bg-transparent font-secondary pl-3 ${
                      darkMode
                        ? 'border-b-white placeholder:text-white placeholder:opacity-40'
                        : 'border-b-slate-900 placeholder:text-slate-400'
                    }`}
                    type="email"
                    name="email"
                    required
                    placeholder="Write your email"
                  />
                </div>

              </div>

              <div className="w-full">
                <label className={`text-sm mb-2 block ${darkMode ? 'text-white' : 'text-slate-900'}`}>
                  Your message <span className="opacity-60">*</span>
                </label>
                <input
                  className={`w-full outline-none border-b h-[60px] bg-transparent font-secondary pl-3 ${
                    darkMode
                      ? 'border-b-white placeholder:text-white placeholder:opacity-40'
                      : 'border-b-slate-900 placeholder:text-slate-400'
                  }`}
                  type="text"
                  name="message"
                  required
                  placeholder="Write your message"
                />
              </div>

              <button
                onMouseEnter={mouseEnterHandler}
                onMouseLeave={mouseLeaveHandler}
                className="rounded py-2 mt-8 w-fit px-10 flex bg-sky-900 cursor-pointer text-white"
                type="submit"
              >
                Send it
              </button>

            </form>
          </motion.div>

        </div>
      </section>

      <Footer />
    </main>
  );
};

export default Contact;